import React, { useState, createContext, useContext } from 'react';

const DispatchingUIContext = createContext();

const DispatchingUIProvider = ({ children }) => {
  const [mutateListFn, setMutateListFn] = useState(null);
  const [mutateSuggestionsListFn, setMutateSuggestionsListFn] = useState(null);
  const [loading, setLoading] = useState({});

  const value = {
    loading,
    setLoading,
    mutateListFn,
    setMutateListFn,
    mutateSuggestionsListFn,
    setMutateSuggestionsListFn,
  };

  return <DispatchingUIContext.Provider value={value}>{children}</DispatchingUIContext.Provider>;
};

const useDispatchingUI = () => useContext(DispatchingUIContext);

export default DispatchingUIContext;

export { DispatchingUIProvider, useDispatchingUI };
